"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfflineResponseInterceptor = void 0;
const ResponseInterceptor_1 = require("./ResponseInterceptor");
class OfflineResponseInterceptor extends ResponseInterceptor_1.ResponseInterceptor {
    constructor(internetStatusManager, axios) {
        super(axios);
        this.internetStatusManager = internetStatusManager;
        this.internetStatusManager = internetStatusManager;
    }
    onFulfilled(response) {
        return __awaiter(this, void 0, void 0, function* () {
            return response;
        });
    }
    onRejected(error) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!(error === null || error === void 0 ? void 0 : error.config)) {
                throw new Error("Request config missing!!!");
            }
            if (error.code === "ERR_NETWORK") {
                console.log("Debug: Received ERR_NERWORK response: ", error);
                this.internetStatusManager.offline();
                return this.rejectResponse(error === null || error === void 0 ? void 0 : error.config, "No Internet", "NO_INTERNET");
            }
            return Promise.reject(error);
        });
    }
}
exports.OfflineResponseInterceptor = OfflineResponseInterceptor;
